import { GatewayClientProvider } from './../gateway-client/gateway-client';
import { Events } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';


@Injectable()
export class SavingsAccountsProvider {
  accounts: any = [];
  settings: any;
  constructor(
    public http: Http,
    public events: Events,
    public gateway: GatewayClientProvider) {
  }

  getAllAccounts() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getSavingsAccounts().then((data) => {
        self.accounts = data;
        self.events.publish("consectus:savings.accounts.updated", data);
        resolve(data);
      }).catch((err) => {
        reject(err);
      })
    })
  }

  getTransactions(accountNumber) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getCustomerAccountTransactions(accountNumber).then((data) => {
        resolve(data);
      })
        .catch((error) => {
          reject(error);
        });
    });
  }

  checkTransferValidation(tranferData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.checkTransferValidation(tranferData).then((data) => {
        resolve(data);
      })
        .catch((error) => {
          reject(error);
        });
    });
  }

  transferMoney(tranferData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.transferMoney(tranferData).then((data) => {
        resolve(data);
      })
        .catch((error) => {
          reject(error);
        });
    });
  }

  transferoutfinal(tranferData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.transferoutfinal(tranferData).then((data) => {
        resolve(data);
      })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getcurrentdate() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getCurrentDate().then((data) => {
        resolve(data);
      })
        .catch((error) => {
          reject(error);
        });
    });
  }

  depositMoney(amount, toAccount, fromAccount = null, fromSortCode = null) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.depositMoney(amount, toAccount, fromAccount, fromSortCode).then(() => {
        resolve(true);
      })
        .catch((error) => {
          reject(error);
        });
    });
  }
  sendMoney(amount, fromAccount, toAccount = null, toSortCode = null) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.sendMoney(amount, fromAccount, toAccount, toSortCode).then(() => {
        resolve(true);
      })
        .catch((error) => {
          reject(error);
        });
    });
  }

  deleteRejected(transaction) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.deleteRejectedTransaction(transaction)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  deleteProductAccount(porduct_applied) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.deleteProductAccount(porduct_applied).then((data: any) => {
        resolve(data)
      }).catch((err) => {
        reject(err);
      })
    })
  }

  getCustomerAllAccounts(customerId, loader = false, token) {
    let self = this;
    return new Promise(function (resolve, reject) {
      if (!loader) {
        resolve(self.accounts)
      }
      else {
        self.gateway.getCustomerAccounts(customerId).then((data: any) => {
          self.accounts = data.data;
          data.data.accounts.map(trans => {
            delete trans.transactions
          })
          resolve(data)
        }).catch((err) => {
          reject(err);
        })
      }
    })
  }
  getCustomerAllSavingsAccounts(customerdata, pageno, pagesize) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getCustomerSavingsAccounts(customerdata, pageno, pagesize).then((data: any) => {
        self.accounts = data.saving;
        resolve(data)
      }).catch((err) => {
        reject(err);
      })
    })
  }

  getMaturityOptions(customer_accounts_id) {
    let self = this;
    return new Promise(function (resolve, reject) {

      self.gateway.getMaturityOptions(customer_accounts_id).then((data: any) => {

        resolve(data)
      }).catch((err) => {
        reject(err);
      })

    })
  }

  selectMaturityOption(selectedOption) {
    let self = this;
    return new Promise(function (resolve, reject) {

      self.gateway.selectMaturityOption(selectedOption).then((data: any) => {
        resolve(data)
      }).catch((err) => {
        reject(err);
      })

    })
  }

  depositMoneyInAccoount(depositMoneyData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.accessTransferIn(depositMoneyData).then((data) => {
        self.accounts = data;
        resolve(data);
      }).catch((err) => {
        reject(err);
      })
    })
  }

  sendMoneyWithin(transferWithinData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.accessTransferWithin(transferWithinData).then((data) => {
        resolve(data);
      }).catch((err) => {
        reject(err);
      })
    })
  }

  approveTransfer(approvedTransferdata) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.approveTransfer(approvedTransferdata).then((data) => {
        resolve(data);
      }).catch((err) => {
        reject(err);
      })
    })
  }

  deniedTransfer(denyTransferdata) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.denyTransfer(denyTransferdata).then((data) => {
        resolve(data);
      }).catch((err) => {
        reject(err);
      })
    })
  }

  approveTransferv2(approvedTransferdata) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.approveTransferv2(approvedTransferdata).then((data) => {
        resolve(data);
      }).catch((err) => {
        reject(err);
      })
    })
  }

  deniedTransferv2(denyTransferdata) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.denyTransferv2(denyTransferdata).then((data) => {
        resolve(data);
      }).catch((err) => {
        reject(err);
      })
    })
  }

  getCountByPendingOrders(pendingData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getCountByPendingOrders(pendingData).then((data) => {

        resolve(data);
      }).catch((err) => {

      }).catch((err) => {
        reject(err);
      })
    })
  }

  getaccountrules() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getaccountrules()
        .then((data: any) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * Get Account balance data
   * @param balanceData 
   */
  getaccountbalance(balanceData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getaccountbalance(balanceData).then((data) => {
        resolve(data);
      }).catch((err) => {
        reject(err);
      })
    })
  }

  /**
     * Get Saving accounts Statements
     * @param customer_accounts_id
     */

  getCustomerAccountStatements(customer_accounts_id) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getCustomerAccountStatements(customer_accounts_id).then((data) => {
        resolve(data);
      }).catch((err) => {
        reject(err);
      })
    })
  }

  download_PDF(bodyData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.downloadPDF(bodyData).then((data) => {
        resolve(data);
      }).catch((err) => {
        reject(err);
      })
    })
  }

  download_periodic_statements(downloadData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.downloadperiodicstatements(downloadData).then((data) => {
        resolve(data);
      }).catch((err) => {
        reject(err);
      })
    })

  }
}


// WEBPACK FOOTER //
// ./src/providers/savings-accounts/savings-accounts.ts